// components/CenteredDialog.js
import React from 'react';
import './CenteredDialog.css';

const CenteredDialog = ({ 
  isOpen, 
  onClose, 
  title, 
  message, 
  type = 'success',
  isConfirm = false,
  isDualAction = false,
  onConfirm = null,
  onPrimaryAction = null,
  onSecondaryAction = null,
  confirmText = 'Yes',
  cancelText = 'No',
  primaryActionText = 'OK',
  secondaryActionText = 'Cancel',
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  const handlePrimaryAction = () => {
    if (onPrimaryAction) {
      onPrimaryAction();
    }
  };

  const handleSecondaryAction = () => {
    if (onSecondaryAction) {
      onSecondaryAction();
    }
  };

  const dismissOnOverlay = !isConfirm && !isDualAction;

  return (
    <div className="centered-dialog-overlay" onClick={dismissOnOverlay ? onClose : undefined}>
      <div className="centered-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="centered-dialog-header">
          <h2 className={`centered-dialog-title ${type}`}>{title}</h2>
          {!isConfirm && !isDualAction && (
            <button
              className="centered-dialog-close"
              onClick={onClose}
              aria-label="Close dialog"
            >
              ×
            </button>
          )}
        </div>
        <div className="centered-dialog-content">
          <p>{message}</p>
        </div>
        <div className="centered-dialog-footer">
          {isDualAction ? (
            <>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleSecondaryAction}
              >
                {secondaryActionText}
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handlePrimaryAction}
              >
                {primaryActionText}
              </button>
            </>
          ) : isConfirm ? (
            <>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCancel}
              >
                {cancelText}
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleConfirm}
              >
                {confirmText}
              </button>
            </>
          ) : (
            <button
              type="button"
              className="btn btn-primary"
              onClick={onClose}
            >
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CenteredDialog;

